import { NavLink } from 'react-router';
import { useRoute } from 'src/router/hooks';
import image from '../../images/modals/tsipka.webp';

import classes from './styles.module.css';
import { useDrawer } from 'src/hooks/useDrawer';

export const SidebarLink = () => {
  const { ROUTE } = useRoute();
  const { closeDrawer } = useDrawer();

  return (
    <NavLink to={ROUTE.CATCH_GAME.get()} onClick={closeDrawer} className={classes.button}>
      <img src={image} alt="catch game image" height={30} width={30} className="w-[30px] h-auto" />
      <p className="text-start w-full text-sm">Catch Easter Chick</p>
    </NavLink>
  );
};
